import { Chip } from '@material-ui/core'
import React, { useState } from 'react'

export default function ReadMoreInline({ text, maxLength = '50', defaultText = '--', readMoreText = 'more', lessText = 'less',chipView='false', chipText }) {
    const [showFullText, setShowFull] = useState(false)
    return (
        <>{!chipView ||chipView === "false" ?
        <span className='read-more-less-blk' >
            {
                text?.length > maxLength ?
                    <div>
                        {
                            showFullText ?
                                <div>
                                    {text}
                                    <span className='read-more-txt' onClick={() => setShowFull(!showFullText)}> {lessText}</span>
                                </div>
                                :
                                <div>
                                    {text?.substring(0, (maxLength - 3))}
                                    <span className='read-more-txt' onClick={() => setShowFull(!showFullText)}> ...{readMoreText}</span>
                                </div>
                        }
                    </div>
                    :
                    <span>{text || defaultText}</span>
            }
        </span>:
        chipView?
            <span className='read-more-less-blk' >
                {chipText?.length? chipText?.length-1 < maxLength ?
                    chipText?.map(item =>
                        (<Chip label={item?.name} size='small' className='chip-class' />)
                    ) :
                    showFullText ?
                        <>
                            {chipText?.map(item =>
                                (<Chip label={item?.name} size='small' className='chip-class' />)
                            )}
                            <Chip label={'...less'} size='small' onClick={() => setShowFull(false)} className='chip-class read-more-txt' />
                        </>
                        : <>{
                            chipText?.filter((item, index) => index < maxLength)?.map(item => (
                                (<Chip label={item?.name} size='small' className='chip-class' />)
                            ))
                        }
                            <Chip label='...more' size='small' onClick={() => setShowFull(true)} className='chip-class read-more-txt' />
                        </>:'--'}
            </span>: null
        }</>
    )
}
